module.exports = __webpack_public_path__ + "static/img/17063B_1_2_R_20220623_LC.7ebc72f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17063B_1_2_R_20220623_LC.png
// module id = IW4s
// module chunks = 0